export const AuthInitialState = {
    admin: false,
    userProfile: null,
    userId: null,
    userEmail: null,
    identityId: null,
    info: { id: null,
            fullName: null, 
            company: null, 
            phoneNumber:null, 
            companyAdress: null, 
            deliveryInfo: null
        }
}

export const ClientOrderInitialState = {
    orderItems: [],
    orders: [],
    additionalInfo: {
        expectedDate: null,
        deliveryMethod: 'self'
    }
}

export const UsersInitialState = {
    poolList: {},
    personalList: null
}

export const InitialRootState = {
    users: {...UsersInitialState},
    auth: {...AuthInitialState},
    clientOrder: {...ClientOrderInitialState}
}